module.exports = __webpack_public_path__ + "static/btn05-f21918f38d23a6dbeb82302a3ec13af6.png";